/* eslint-disable global-require */
/* eslint-disable jsx-a11y/media-has-caption */
import {Button, Modal} from 'letrus-ui';
import styles from './OCRTourModal.module.scss';

export interface OCRTourModalProps {
  onClickButton(): void;
}

function OCRTourModal({onClickButton}: OCRTourModalProps): JSX.Element {
  return (
    <Modal id="ocrTourModal" className={styles.modal} closeButton>
      <div className={styles.wrapper} data-testid="ocrTourModal">
        <hr className={styles.separator} />

        <div className={styles.content}>
          <h2>Por que enviar redações manuscritas?</h2>

          <p>
            Agora, além de digitar seu texto na Letrus, você também pode enviar
            suas redações manuscritas!
          </p>

          <h3>Como funciona:</h3>

          <ol>
            <li>Envie uma foto da redação manuscrita.</li>

            <li>A foto são processadas por um serviço de transcrição.</li>

            <li>O texto transcrito aparece no editor da Letrus.</li>

            <li>Revise a paragrafação e a transcrição do texto.</li>
          </ol>

          <h3>Veja como funciona:</h3>

          <video width="1280" height="720" controls>
            <source
              src={require('../../../../assets/videos/ocr-tour-video.mp4')}
              type="video/mp4"
            />
          </video>
        </div>

        <hr className={styles.separator} />

        <Button variant="primary" onClick={onClickButton} type="button">
          Legal!
        </Button>
      </div>
    </Modal>
  );
}

export default OCRTourModal;
